import { useQuery } from '@tanstack/react-query';
import { api } from 'src/services';
import { UseQueryOverrideOptions } from '../common';
import { Condition, Practitioner } from 'src/models';

export type UseGetAppointmentConditionListParams = {
  practitioner_id: Practitioner['practitioner_id'];
  appt_creation: boolean;
  appointment_type_id: number;
};

export type GetAppointmentConditionListResponse = {
  conditions: (Pick<
    Condition,
    | 'condition_name'
    | 'appointment_type'
    | 'created_by'
    | 'last_modified_by'
    | 'specialty_id'
  > & { condition_id: Condition['id'] })[];
  practitioner_emails: string;
};

export const useGetAppointmentConditionList = (
  params: UseGetAppointmentConditionListParams,
  options: UseQueryOverrideOptions<GetAppointmentConditionListResponse> = {}
) => {
  return useQuery({
    ...options,
    queryKey: ['appointmentConditionList', params],
    queryFn: () =>
      api.post('/appointment/type', params).then((res) => res.data),
  });
};
